<script lang="ts">
	//Formatters
	import { format } from '../../../../services/i18n';
	//Event dispatcher
	import { createEventDispatcher, setContext } from 'svelte';
	//Components
	import WizzardWrapper from '../../../../components/ModalWizzard/WizzardWrapper.svelte';
	import DayPickerWrapper from '../SchedulesComponents/DayPickerWrapper.svelte';
	import TimePickerWrapperSchedule from '../SchedulesComponents/TimePickerWrapperSchedule.svelte';
	import ActionSelectionWrapper from '../SchedulesComponents/ActionSelectionWrapper.svelte';
	import RollerSelectorWrapper from '../SchedulesComponents/RollerSelectorWrapper.svelte';
	import ActionBrightnessSelectorWrapper from '../SchedulesComponents/ActionBrightnessSelectorWrapper.svelte';
	//Stores
	import { readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { writable } from 'svelte/store';
	//Design system  components
	import { toast } from '@Shelly/shelly-design-system';
	import ActionBrightnessTemperatureDurationWrapper from '../SchedulesComponents/ActionBrightnessTemperatureDurationWrapper.svelte';
	import ActionBrightnessDurationWrapper from '../SchedulesComponents/ActionBrightnessDurationWrapper.svelte';

	export let props: any = {},
		showModal = true;

	const dispatch = createEventDispatcher();

	const deviceStatus = readDeviceStatus(props.device.id);
	const calibrated =
		deviceStatus?.rollers?.[0]?.current_pos !== 101 && deviceStatus?.rollers?.[0]?.positioning;

	let rollerHeight = props.rollerHeight;
	let rollerState = props.rollerState;
	let hoursRange = props.mode !== props.types[0] ? [0, 12] : [0, 23];
	let brightness =
		Object.keys(props).includes('brightness') &&
		typeof props.brightness !== undefined &&
		props.device.category !== 'roller';
	const actionTitle = $format('schedules_wizard_items_action', {
		default: 'Action',
	});

	const createScheduleStore = () => {
		let options;
		let _options = [];
		if (props.device.category === 'roller') {
			options = ['open', 'close'];
		} else {
			options = props.commands;
		}
		if (calibrated) {
			options.push('position');
		}
		if (brightness && !options.includes('brightness')) {
			options.push('brightness');
		} else if (!brightness && options.includes('brightness')) {
			options.splice(options.indexOf('brightness'), 1); //because remains from previous device
		}

		options.forEach((prop, index) => {
			if (props.device.category === 'sensor') {
				let motionOptions = [$format('sensor_enable'), $format('sensor_disable')];
				_options.push(motionOptions[index]);
			} else {
				_options.push(prop);
			}
		});

		let selection = props.selection || options[0];

		const { subscribe, set, update } = writable({
			...props,
			// time,
			// days,
			// mode,
			options,
			_options,
			// value,
			selection,
			hoursRange,
			rollerHeight,
			rollerState,
			min: props.tempRange[0],
			max: props.tempRange[1],
			valuePrefix: 'K',
			calibrated,
			// brightness
		});
		return {
			subscribe,
			change: (new_schedule) =>
				update((schedule) => {
					schedule = { ...schedule, ...new_schedule };
					return schedule;
				}),
			clear: () => {
				update((schedule) => {
					schedule = {};
					return schedule;
				});
			},
		};
	};

	const scheduleStore = createScheduleStore();

	setContext('schedule', scheduleStore);

	// beforeUpdate(() => {
	// 	scheduleStore.change({
	// 		hoursRange:
	// 			$scheduleStore.mode !== $scheduleStore.types[0] ? [0, 12] : [0, 23]
	// 	});
	// });

	const handleSave = () => {
		if (props.device.category !== 'roller') {
			if (
				$scheduleStore.brightness === '101' &&
				$scheduleStore.selection === '101' &&
				$scheduleStore.colorTemperature === '101'
			) {
				return toast.open({
					type: 'info',
					title: $format('schedule_selection_info_toast', {
						default: 'Please select brightness, balance or action value.',
					}),
				});
			} else {
				$scheduleStore.callback ? $scheduleStore.callback($scheduleStore) : '';
				dispatch('close');
			}
		} else {
			if ($scheduleStore.rollerState !== '101') {
				scheduleStore.change({ rollerState: $scheduleStore.rollerState });
			}
			if (
				$scheduleStore.device.category === 'roller' &&
				(typeof $scheduleStore.rollerHeight === 'undefined' ||
					$scheduleStore.rollerHeight === '101') &&
				(typeof $scheduleStore.rollerState === 'undefined' ||
					$scheduleStore.rollerState === '101')
			) {
				return toast.open({
					type: 'info',
					title: $format('schedule_selection_roller_info_toast', {
						default: 'Please select roller state or roller height.',
					}),
					duration: 1000,
				});
			}
			$scheduleStore.brightness
				? scheduleStore.change({ selection: $scheduleStore.brightness })
				: '';
			scheduleStore.change({ brightness: '' });
			$scheduleStore.callback ? $scheduleStore.callback($scheduleStore) : '';
			dispatch('close');
		}
	};

	const wizardItems = [
		{
			active: true,
			activeIndex: 0,
			disabled: false,
			showMoreDots: false,
			stepNumber: 1,
			title: $format('schedules_wizard_items_week_days', {
				default: 'Week days',
			}),
			tooltipTitle: $format('choose_weekday'),
			component: DayPickerWrapper,
		},
		{
			active: false,
			activeIndex: 1,
			disabled: false,
			showMoreDots: false,
			stepNumber: 2,
			title: $format('schedules_wizard_items_time', { default: 'Time' }),
			component: TimePickerWrapperSchedule,
			tooltipTitle: $format('choose_time'),
		},
	];

	if (props.device.category !== 'roller') {
		wizardItems.push({
			active: false,
			activeIndex: 2,
			disabled: false,
			showMoreDots: false,
			stepNumber: 3,
			title: actionTitle,
			component: ActionSelectionWrapper as any,
			tooltipTitle: $format('select_type', {
				values: { type: $format('process_action') },
			}),
		});
	} else {
		wizardItems.push({
			active: false,
			activeIndex: 2,
			disabled: false,
			showMoreDots: false,
			stepNumber: 3,
			title: actionTitle,
			component: RollerSelectorWrapper,
			tooltipTitle: $format('select_type', {
				values: { type: $format('process_action') },
			}),
		});
	}

	if (Object.keys(props).includes('colorTemperature') && brightness) {
		wizardItems.splice(2, 1, {
			active: false,
			activeIndex: wizardItems.length,
			disabled: false,
			showMoreDots: false,
			stepNumber: wizardItems.length + 1,
			title: actionTitle,
			component: ActionBrightnessTemperatureDurationWrapper,
			tooltipTitle: $format('select_type', {
				values: { type: $format('process_action') },
			}),
		});
	} else if (brightness && !Object.keys(props).includes('duration')) {
		wizardItems.splice(2, 1, {
			active: false,
			activeIndex: wizardItems.length,
			disabled: false,
			showMoreDots: false,
			stepNumber: wizardItems.length + 1,
			title: actionTitle,
			component: ActionBrightnessSelectorWrapper,
			tooltipTitle: $format('select_type', {
				values: { type: $format('roller_position') },
			}),
		});
	} else if (brightness && Object.keys(props).includes('duration')) {
		wizardItems.splice(2, 1, {
			active: false,
			activeIndex: wizardItems.length,
			disabled: false,
			showMoreDots: false,
			stepNumber: wizardItems.length + 1,
			title: actionTitle,
			component: ActionBrightnessDurationWrapper,
			tooltipTitle: $format('select_type', {
				values: { type: $format('roller_position') },
			}),
		});
	}

	// if (Object.keys(props).includes('duration') && props.duration !== undefined) {
	// 	wizardItems.push({
	// 		active: false,
	// 		activeIndex: wizardItems.length,
	// 		disabled: false,
	// 		showMoreDots: false,
	// 		stepNumber: wizardItems.length + 1,
	// 		title: 'Duration',
	// 		component: DurationWrapper,
	// 		tooltipTitle: $format('select_type', {
	// 			values: { type: $format('roller_position') }
	// 		})
	// 	});
	// }

	const updateSchedule = (e) => {
		scheduleStore.change(e.detail);
	};
</script>

<WizzardWrapper
	bind:showModal
	title={$format('weekly_schedules')}
	wizardContentClasses="pl-0 pr-0"
	{wizardItems}
	callback={handleSave}
	on:updateStore={updateSchedule}
/>
